import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

Vue.use(Vue2Filters)

// HAND MADE FILTERS
Vue.filter('humanizar_fecha', (value) => {
	moment.locale('es');
	return moment(value).format("dddd D [de] MMMM");
	// return moment(value).format("dddd D [de] MMMM [del] YYYY, h:mm:ss a");
});

Vue.filter('humanizar_diferencia', (value) => {
	moment.locale('es');
	let string = moment(value).fromNow()
	switch(string){
		case 'en unos segundos':
			return "Justo ahora"
			break;
		default:
			return string
			break;
	}
});

Vue.filter('solo_hora', (value) => {
	moment.locale('es');
	return moment(value).format("h:mm a");
});